'use client';

import React from 'react';
import Head from 'next/head';
import { nativoAdManager } from '@benzinga/ads-utils';
//import { nativoAdManager } from '@benzinga/ads-utils';
//import Script from 'next/script';

export const NativoScript: React.FC<{ pageTargeting?: Record<string, string | string[]> }> = ({ pageTargeting }) => {
  React.useEffect(() => {
    window.ntv = window.ntv || {};
    window.ntv.cmd = window.ntv.cmd || [];
    nativoAdManager.setTargeting(pageTargeting || {});
    window.ntv.cmd.push(function () {
      window.PostRelease.Start();
    });
  }, [pageTargeting]);

  return (
    <>
      <Head>
        <script
          async
          data-ntv-set-no-auto-start
          id="nativo-script"
          src="https://s.ntv.io/serve/load.js"
          type="text/javascript"
        />
      </Head>
      {/* <Script async={true} data-ntv-set-no-auto-start id="nativo-script" src="https://s.ntv.io/serve/load.js" /> */}
    </>
  );
};

export default NativoScript;
